//@flow
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { compose, lifecycle, withProps } from 'recompose'
import Loading from '../../ui/views/loading'
import {
  isCharityConnectedFailed,
  isCharityConnectedOK,
  isCharityConnecting
} from './selectors'
import { isSessionLoaded, getUserCharityId } from '../session/selectors'
import { connectWithAccount } from './actions'

const mapStateToProps = state => {
  return {
    isSessionLoaded: isSessionLoaded(state),
    isFailed: isCharityConnectedFailed(state),
    isSuccess: isCharityConnectedOK(state),
    isFailure: isCharityConnectedFailed(state),
    isConnecting: isCharityConnecting(state),
    charityId: getUserCharityId(state)
  }
}

const mapDispatchToProps = {
  connectWithAccount
}

const withStripeConnect = connect(mapStateToProps, mapDispatchToProps)

const withQueryParams = withProps(props => {
  const { location, history } = props
  const urlParams = new URLSearchParams(location.search)
  const code = urlParams.get('code')
  const state = urlParams.get('state')
  //console.log('Redirect response', code, state)
  return {
    redirectNoCode() {
      history.replace('/explore')
    },
    redirectToLogin() {
      history.replace('/login', { returnUrl: location })
    },
    redirectToMyCharity() {
      history.replace('/mycharity')
    },
    code,
    state
  }
})

const connectAccountOnLoad = lifecycle({
  componentWillMount() {
    const { code, redirectNoCode } = this.props
    if (!code) {
      console.error('Stripe redirect without OAuth code')
      redirectNoCode()
    }
  },
  componentDidMount() {
    const {
      isSessionLoaded,
      redirectToMyCharity,
      charityId,
      connectWithAccount,
      code
    } = this.props
    if (isSessionLoaded && charityId) {
      connectWithAccount(code).then(result => {
        if (/already connected/i.test(result.message)) {
          redirectToMyCharity()
        }
      })
    }
  },
  componentDidUpdate() {
    const {
      redirectToLogin,
      redirectToMyCharity,
      charityId,
      code,
      isSessionLoaded,
      isSuccess,
      connectWithAccount
    } = this.props

    if (isSuccess) {
      redirectToMyCharity()
    }
    if (isSessionLoaded && !charityId) {
      redirectToLogin()
    }
    if (isSessionLoaded) {
      if (!charityId) {
        return redirectToLogin()
      } else {
        connectWithAccount(code).then(result => {
          if (/already connected/i.test(result.message)) {
            redirectToMyCharity()
          }
        })
      }
    }
  }
})

const decorate = compose(
  withRouter,
  withQueryParams,
  withStripeConnect,
  connectAccountOnLoad
)

export default decorate(Loading)



// WEBPACK FOOTER //
// ./src/services/stripe/ConnectCallback.js